var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "available-areas" }, [
      _c(
        "div",
        { staticClass: "typography" },
        [
          _c("div", { staticClass: "typography" }, [
            _c("h2", [_vm._v(_vm._s(_vm.t("app-selected-service-areas")))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "standard-form-style" }, [
            _c(
              "div",
              { staticClass: "ui-form-row col-filters" },
              [
                _c("app-select", {
                  attrs: { label: _vm.t("app-state"), options: _vm.states },
                  on: { input: _vm.refresh },
                  model: {
                    value: _vm.state,
                    callback: function ($$v) {
                      _vm.state = $$v
                    },
                    expression: "state",
                  },
                }),
                _vm._v(" "),
                _c("app-input", {
                  attrs: { type: "search", label: _vm.t("app-county") },
                  on: { input: _vm.refresh },
                  model: {
                    value: _vm.county,
                    callback: function ($$v) {
                      _vm.county = $$v
                    },
                    expression: "county",
                  },
                }),
                _vm._v(" "),
                _c("app-input", {
                  attrs: { type: "search", label: _vm.t("app-city") },
                  on: { input: _vm.refresh },
                  model: {
                    value: _vm.city,
                    callback: function ($$v) {
                      _vm.city = $$v
                    },
                    expression: "city",
                  },
                }),
                _vm._v(" "),
                _c("app-input", {
                  attrs: { type: "search", label: _vm.t("app-zip") },
                  on: { input: _vm.refresh },
                  model: {
                    value: _vm.zip,
                    callback: function ($$v) {
                      _vm.zip = $$v
                    },
                    expression: "zip",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "actions" }, [
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.$emit("removeAllServiceAreas")
                    },
                  },
                },
                [_vm._v("Remove All Areas")]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "vuetable",
            {
              ref: "vuetable",
              attrs: {
                "api-url": _vm.route,
                "http-fetch": _vm.getData,
                fields: _vm.fields,
                transform: _vm.transformData,
                "show-sort-icons": false,
                "no-data-template": _vm.t("app-no-data-available"),
                css: { tableClass: "ui-table clickable-rows" },
                "track-by": "zip",
              },
              on: {
                "vuetable:pagination-data": _vm.onPaginationData,
                "vuetable:row-clicked": function ($event) {
                  return _vm.$emit("removeServiceArea", $event)
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "remove-slot" }, slot: "remove-slot" },
                [
                  _c("button", [
                    _c("span", { staticClass: "material-icons-outlined" }, [
                      _vm._v("remove"),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("pagination", {
            ref: "pagination",
            on: { "vuetable-pagination:change-page": _vm.onChangePage },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }